import {http} from '@/http'

export default {
  getBalance(employeeId) {
    return http.get(`/vacations/balance/${employeeId}`)
  },
  getPeriods(contractId) {
    return http.get(`/vacations/periods/${contractId}`)
  },
  createRequest(data) {
    return http.post('/vacations/requests', data)
  },
  getRequests(params) {
    return http.get('/vacations/requests', {params})
  },
  getRequest(id) {
    return http.get(`/vacations/requests/${id}`)
  },
  getRequestsByEmployee(employeeId) {
    return http.get(`/vacations/requests/employee/${employeeId}`)
  },
  approveRequest(id) {
    return http.put(`/vacations/requests/${id}/approve`)
  },
  rejectRequest(id, data) {
    return http.put(`/vacations/requests/${id}/reject`, data)
  },
  cancelRequest(id, data) {
    return http.put(`/vacations/requests/${id}/cancel`, data)
  },
  downloadXlsx(data) {
    return http.post('/vacations/requests/xlsx', data, {responseType: 'blob'})
  },
}
